/**
 * Maps URL sort parameter key (without '-' direction prefix) to Data API sort_type.
 * Both 'key' and '-key' map to the same API value; direction is handled separately.
 */
export const SORT_TYPE_MAP: Record<string, string> = {
  bull_bear: 'bull_bear_score',
  vola: 'stock_vola',
  abc: 'sentiment',
  price: 'stock_price',
  esg: 'esg',
  esg_risk: 'esg_risk',
  general_risk: 'general_risk',
  credit_risk: 'credit_watch',
  immediate_risk: 'immediate_risk',
  eb_sim: 'eb_sim',
  eb_sim_risk: 'eb_sim_risk',
  senti: 'sentiment',
  count: 'volume',
};

/**
 * Resolves a URL sort parameter to an API sort_type and direction.
 */
export function resolveSortType(
  sortParam: string,
  defaultType = 'sentiment',
): { sortType: string; sortValue: 'asc' | 'desc' } {
  if (!sortParam) {
    return { sortType: defaultType, sortValue: 'desc' };
  }
  const isAsc = sortParam.startsWith('-');
  const key = isAsc ? sortParam.substring(1) : sortParam;
  return {
    sortType: SORT_TYPE_MAP[key] ?? defaultType,
    sortValue: isAsc ? 'asc' : 'desc',
  };
}

/**
 * Resolves a URL sort parameter to a client-side order string.
 * Each component provides its own mapping of full sort params (including '-' prefix) to field names.
 */
export function resolveSortOrder(
  sortParam: string,
  mapping: Record<string, string>,
  defaultOrder: string,
): string {
  return mapping[sortParam] ?? defaultOrder;
}
